import _ from 'lodash';

import Conversation from 'models/conversation';

function getCustomerStores(stores, { customerId }) {
  return customerId && stores.customers.has({ id: customerId }) ? stores.customers.storesFor(customerId) : null;
}

function getConversationsStore(stores, { customerId }) {
  if (customerId) {
    const customerStores = getCustomerStores(stores, { customerId });
    return customerStores && customerStores.conversations;
  }
  return stores.conversations;
}

function getActiveConversationAttributes(stores, { customerId, selectAttributes }) {
  const conversationsStore = getConversationsStore(stores, { customerId });
  if (!conversationsStore) {
    return null;
  }
  const activeConversation = _.last(
    conversationsStore.findAll({ filter: c => c.status !== Conversation.Status.CLOSED, select: selectAttributes })
  );
  return activeConversation;
}

function getLatestConversationAttributes(stores, { customerId, selectAttributes }) {
  const conversationsStore = getConversationsStore(stores, { customerId });
  if (!conversationsStore) {
    return null;
  }
  const latestConversation = _.last(conversationsStore.findAll({ select: selectAttributes, sortBy: c => c.createdAt }));
  return getActiveConversationAttributes(stores, { customerId, selectAttributes }) || latestConversation || null;
}

export function getLatestConversationId(stores, { customerId } = {}) {
  const latestConversation = getLatestConversationAttributes(stores, {
    customerId,
    selectAttributes: ['id'],
  });
  return latestConversation ? latestConversation.id : null;
}

export * from './tasks';



// WEBPACK FOOTER //
// ./src/scripts/application/selectors/customer/index.js